import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { MimeTypeBase, Project, ProjectService } from '../../../types/entities';
import { MediaAsset } from '../../../types/media-assets';
import { MaybeUndef } from '../../../types/system';
import {
  getImageExtension,
  getResizedImageUrl,
} from '../../../utils/image-service/image-service';
import { ReactImage } from '../../../utils/react-image/react-image';
import { mediaAssetsService } from '../../../transport';

export interface OwnProps extends React.HTMLProps<HTMLImageElement> {
  file: MediaAsset;
  imageClassName?: string;
  width: number;
  height: number;
  maxWidth?: number | string;
  maxHeight?: number | string;
  loading?: React.ReactElement;
  fallback?: React.ReactElement;
}

export interface StateProps {
  fileService: MaybeUndef<ProjectService>;
  imageService: MaybeUndef<ProjectService>;
  project: MaybeUndef<Project>;
  organizationId: MaybeUndef<string>;
}

type Props = OwnProps & StateProps;

export const ResizedImage: React.FunctionComponent<Props> = ({
  file,
  imageClassName,
  fileService,
  imageService,
  width,
  height,
  maxWidth,
  maxHeight,
  fallback,
  loading,
  project,
  organizationId,
  ...props
}) => {
  const { mimeTypeParsed, acl, path } = file;
  const [imageToken, setImageToken] = useState('');

  useEffect(() => {
    setImageToken(undefined);
    getImageToken(path).then((token) => setImageToken(token));
  }, [path]);

  if (
    !fileService ||
    !imageService ||
    mimeTypeParsed.type !== MimeTypeBase.Image
  ) {
    return fallback === undefined ? null : fallback;
  }

  const getImageToken = async (path: string): Promise<string> => {
    if (acl === 'private') {
      const token = await mediaAssetsService.getImageToken({
        organizationId,
        project,
        path,
      });
      return token;
    }
  };

  const extension = getImageExtension(file);
  const src = getResizedImageUrl(
    imageService,
    path,
    width,
    height,
    imageToken,
    extension,
  );

  const style = {
    maxWidth: maxWidth === undefined ? width : maxWidth,
    maxHeight: maxHeight === undefined ? height : maxHeight,
  };

  if (acl === 'private' && !imageToken) {
    return <></>;
  }

  const reactImageProps = _.omit(props, ['dispatch']) as any;
  return (
    <ReactImage
      {...reactImageProps}
      src={src}
      className={imageClassName}
      loader={loading}
      unloader={fallback}
      style={style}
    />
  );
};
